import ComponentManager from '@/Management/ComponentManager';
import UIListener from '@/UIListener/UIListener';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import RADApplication from '@/Management/RADApplication';
import Utilities from '@/Utility/Utilities';

export default class SystemadminAccessUIListener extends UIListener {

    constructor() {
        super();
    }

    public onBeforeSave(context: DetailViewContext): boolean {
        this.updateCache();
        return true;
    }

    public onBeforeApply(context: DetailViewContext): JQueryPromise<boolean> {
        this.updateCache();
        return Utilities.resolveImmediately(true);
    }

    private updateCache(): void {
        RADApplication.getInstance().updateCache();
    }
}

ComponentManager.setUIListener('SystemadminAccessUIListener', SystemadminAccessUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.SystemadminAccessUIListener', SystemadminAccessUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');